import React from "react";
import { useTheme } from "@mui/material/styles";
import {
    Toolbar,
    // Typography,
    Avatar,
    Box,
    Select,
    MenuItem,
    FormControl,
    Menu,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PinDropIcon from "@mui/icons-material/PinDrop";
import HomeIcon from "@mui/icons-material/Home";
import LogoutIcon from "@mui/icons-material/Logout";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import {
    StyledAppBar,
    StyledButton,
} from "../Style/health-chart.style";
// import { getFilterQuery } from "../../../utils/helper";
import logo from "../../../assests/logo-preview.png";
import { People } from "@mui/icons-material";
// import { useLocation } from "react-router-dom";

export default function Header({
    selectedDistrict,
    setSelectedDistrict,
    districts,
    districtsLoading,
    anchorEl,
    setAnchorEl,
    handleAvatarClick,
    handleMenuClose,
    handleLogout,
    handleDateFilterClick,
    tabValue,
    setTabValue,
    navigate
}) {
    const theme = useTheme();
    // const location = useLocation();
    // const queryParams = Object.fromEntries(new URLSearchParams(location?.search));
    const downloadFiles = () => {
        const files = [
            "https://midorihealths.com/Master_Data.xlsx",
        ];
        files.forEach((file) => {
            const link = document.createElement("a");
            link.href = file;
            link.download = file.split("/").pop();
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    };
    return (
        <StyledAppBar position="static">
            <Toolbar sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 2,
                padding: '8px 16px',
                [theme.breakpoints.down('sm')]: {
                    gap: 1,
                    '& > *': {
                        margin: '4px 0'
                    }
                }
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 100 }}>
                    <Box
                        component="img"
                        src={logo}
                        alt="MIDORI Logo"
                        sx={{
                            height: { xs: '50px', sm: '60px', md: '70px' },
                            width: 'auto',
                            objectFit: 'contain'
                        }}
                    />
                </Box>

                <Box sx={{
                    flex: '1 1 auto',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    [theme.breakpoints.down('md')]: {
                        justifyContent: 'center',
                        width: '100%',
                        order: 1
                    }
                }}>
                    <Box sx={{
                        minWidth: 250,
                        maxWidth: 500,
                        width: '100%',
                        display: 'flex',
                        marginRight: '100px',
                        justifyContent: 'center',
                        [theme.breakpoints.down('md')]: {
                            justifyContent: 'center'
                        }
                    }}>
                        <StyledButton variant="contained">
                            Chief Minister's Health For All
                        </StyledButton>
                    </Box>
                </Box>

                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    flexWrap: 'wrap',
                    [theme.breakpoints.down('sm')]: {
                        '& > *': {
                            flex: '1 1 100%',
                            maxWidth: '100%',
                            '& > div': {
                                width: '100%',
                                justifyContent: 'center'
                            }
                        }
                    }
                }}>
                    <div
                        onClick={handleDateFilterClick}
                        style={{
                            color: "#606060",
                            cursor: "pointer",
                            display: 'flex',
                            alignItems: 'center',
                            padding: '8px 12px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                        }}
                    >
                        <CalendarMonthIcon sx={{ fontSize: "22px", marginRight: "8px" }} />
                        Date Filter
                    </div>

                    <FormControl
                        variant="outlined"
                        size="small"
                        sx={{ minWidth: 150 }}
                    >
                        <Select
                            value={selectedDistrict}
                            onChange={(e) => setSelectedDistrict(e.target.value)}
                            displayEmpty
                            disabled={districtsLoading}
                            startAdornment={<PinDropIcon sx={{ color: "#606060" }} />}
                            endAdornment={districtsLoading ? null : <KeyboardArrowDownIcon sx={{ color: "#606060" }} />}
                            sx={{ borderRadius: "4px" }}
                            IconComponent={() => null}
                            renderValue={(selected) => {
                                if (districtsLoading) return 'Loading districts...';
                                if (selected === 'ALL') return 'ALL DISTRICTS';
                                const selectedDistrictObj = (districts || []).find(d => d.value === selected);
                                return selectedDistrictObj ? selectedDistrictObj.label : 'Select District';
                            }}
                        >
                            <MenuItem value="ALL">ALL DISTRICTS</MenuItem>
                            {(districts || []).map((obj, i) => (
                                <MenuItem key={i} value={obj.value}>
                                    {obj.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    {tabValue || tabValue === 0 ? (
                        <HomeIcon
                            onClick={() => setTabValue(false)}
                            sx={{ cursor: "pointer", color: "#606060", fontSize: "30px" }}
                        />
                    ) : (
                        ""
                    )}
                    <Avatar
                        alt="User"
                        src="/placeholder.svg?height=40&width=40"
                        sx={{ cursor: "pointer" }}
                        onClick={handleAvatarClick}
                    />
                </Box>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                >
                 {/* <MenuItem onClick={() => navigate('/district-screening')} sx={{ color: "#606060" }}>
                            District Screening
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                const queryString = getFilterQuery({ role_type: queryParams?.role_type })
                                navigate(`/final-dashboard?${queryString}`)
                            }}
                            sx={{ color: "#606060" }}
                        >
                            Overview
                        </MenuItem> */}
                    <MenuItem onClick={() => {navigate('/staff-data')}} sx={{ color: "#606060" }}>
                        <People sx={{ fontSize: "20px", marginRight: "10px" }} />
                        Staff
                    </MenuItem>
	    	    <MenuItem onClick={downloadFiles} sx={{ color: "#606060" }}>
                        <People sx={{ fontSize: "20px", marginRight: "10px" }} />
                        Download Data Sheet
                    </MenuItem>
                    <MenuItem onClick={handleLogout} sx={{ color: "#606060" }}>
                        <LogoutIcon sx={{ fontSize: "20px", marginRight: "10px" }} />{" "}
                        Logout
                    </MenuItem>
                </Menu>
            </Toolbar>
        </StyledAppBar>
    );
}
